import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { resetOutletScroll } from 'teacher-ui-client/modifiers/reset-scroll'
import { t } from 'ember-intl'
import { on } from '@ember/modifier'

interface Signature {
  Element: HTMLButtonElement
}

export const ScrollToTop: TOC<Signature> = <template>
  <button
    class="hover:text-dusty-black-100 text-white"
    ...attributes
    type="button"
    {{on "click" resetOutletScroll}}
    data-test-back
  >
    <PhosphorIcon @icon="phosphor-caret-up-fill" />
    {{t "components.footerMain.scrollToTop"}}
  </button>
</template>

export default ScrollToTop
